/* @flow */

export default class AvailableCreditLimit {
    availableCreditLimitDataSeries: [];
    maxCreditLimit: number;
  }
  